var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPurchase = function SvgPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#purchase_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#040404",
    fillOpacity: 0.03,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C34CC",
    d: "M40.026-6.556a1 1 0 0 1 1.414 0L54.169 6.172a4 4 0 0 1 0 5.657l-4.717 4.718L33.187.283z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#purchase_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 55,
    x: 3.5,
    y: 3.5,
    stroke: "#E9E9E9",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 22,
    y: 52,
    fill: "#9F9F9F",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 22,
    y: 32,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 22,
    y: 35,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 22,
    y: 38,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 22,
    y: 41,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#500DC3",
    fillOpacity: 0.84,
    d: "M16 54.044H8.727v-2.727q0-.84.313-1.407.312-.57.86-.863a2.55 2.55 0 0 1 1.235-.294q.699 0 1.243.294.543.295.856.87.309.576.309 1.417v1.808H12.46v-1.63q0-.49-.17-.803a1.08 1.08 0 0 0-.47-.461 1.5 1.5 0 0 0-.685-.153q-.387 0-.682.153-.295.15-.458.465-.167.312-.167.806v1.207H16zm-2.294-9.455h-3.16v-1.286H16v1.246h-.97v.057q.459.185.75.608.291.418.291 1.033 0 .535-.238.948a1.65 1.65 0 0 1-.7.64q-.461.23-1.114.23h-3.473V46.78h3.274q.518 0 .823-.285.306-.283.306-.745 0-.285-.139-.55a1.1 1.1 0 0 0-.412-.437q-.276-.174-.692-.174M16 42.38h-5.454v-1.246h.909v-.057a1.36 1.36 0 0 1-.988-1.346q0-.106.011-.238.007-.135.025-.224h1.182q-.028.082-.05.26a2.4 2.4 0 0 0-.024.337q0 .351.152.632.15.277.416.437.267.16.614.16H16zm.107-5.72q0 .818-.36 1.403-.358.583-.99.899-.636.312-1.463.312-.831 0-1.467-.32a2.4 2.4 0 0 1-.994-.901q-.359-.587-.359-1.385 0-.664.245-1.176.242-.514.686-.82.44-.306 1.03-.348v1.229q-.395.075-.657.355-.267.276-.267.742 0 .394.213.692.21.299.604.466.395.162.945.163.557 0 .959-.163.398-.164.614-.459.213-.297.213-.7 0-.283-.107-.507a1 1 0 0 0-.316-.38 1.2 1.2 0 0 0-.5-.21v-1.228q.579.046 1.026.34.444.296.696.803.248.508.248 1.194m-3.303-4.277H16v1.285H8.727v-1.257h2.745v-.064a1.58 1.58 0 0 1-.728-.593q-.27-.405-.27-1.03 0-.568.238-.99.239-.423.696-.654.459-.234 1.119-.234H16v1.285h-3.274q-.55 0-.856.284-.309.281-.309.789 0 .34.15.61.144.267.422.42.277.15.671.149m3.306-6.017q0 .519-.185.934-.188.412-.554.653-.365.238-.902.238-.461 0-.763-.17a1.3 1.3 0 0 1-.483-.465 2.4 2.4 0 0 1-.273-.665 5.4 5.4 0 0 1-.139-.77q-.05-.48-.089-.778-.042-.298-.127-.433-.089-.139-.274-.139H12.3q-.402 0-.622.238t-.22.686q0 .472.206.75.206.272.487.368l-.17 1.2a1.9 1.9 0 0 1-.832-.468 2.04 2.04 0 0 1-.504-.8 3 3 0 0 1-.17-1.043q0-.394.092-.785.092-.39.305-.714.21-.323.572-.518.362-.2.905-.199H16v1.236h-.75v.042q.228.118.427.33.195.21.316.53.117.316.117.742m-.944-.334q0-.387-.153-.671a1.13 1.13 0 0 0-.412-.437 1.05 1.05 0 0 0-.558-.156h-.642q.049.06.092.206.042.142.075.32.031.177.056.351l.043.302q.04.287.128.515.089.226.248.358.158.132.405.132.356 0 .536-.26.181-.258.181-.66m-3.179-7.75.128 1.172a.9.9 0 0 0-.334.174.9.9 0 0 0-.252.327 1.2 1.2 0 0 0-.096.504q0 .402.174.675.175.27.451.266a.47.47 0 0 0 .387-.174q.15-.181.245-.596l.2-.93q.166-.775.528-1.151.363-.38.949-.384.515.004.909.302.39.294.61.82.22.525.22 1.208 0 1.001-.419 1.612-.422.61-1.175.728l-.12-1.254a.88.88 0 0 0 .557-.362q.188-.277.188-.72 0-.459-.188-.736-.188-.28-.465-.28a.48.48 0 0 0-.387.18q-.153.18-.235.555l-.195.93q-.164.784-.55 1.161-.39.377-.988.373a1.4 1.4 0 0 1-.873-.273 1.8 1.8 0 0 1-.576-.778 3 3 0 0 1-.206-1.154q0-.959.409-1.51.408-.553 1.104-.685m4.12-3.192q0 .821-.341 1.417-.345.594-.973.913-.633.32-1.488.32-.842 0-1.478-.32a2.4 2.4 0 0 1-.994-.902q-.359-.58-.359-1.36 0-.505.164-.952.16-.45.497-.795a2.3 2.3 0 0 1 .86-.547q.518-.2 1.235-.2h.394v4.472h-.866v-3.239a1.4 1.4 0 0 0-.657.16q-.291.156-.458.437-.168.276-.167.646 0 .395.192.693.187.297.497.465.305.163.67.167h.757q.477 0 .817-.174.337-.175.519-.487.177-.312.177-.731 0-.281-.078-.508a1.1 1.1 0 0 0-.238-.394 1 1 0 0 0-.387-.253l.135-1.2q.476.114.83.433.353.316.548.81.192.495.192 1.13"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "purchase_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "purchase_svg__b",
    width: 42,
    height: 58,
    x: 2,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_532_287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_532_287",
    result: "shape"
  })))));
};
export default SvgPurchase;